<template>
  <div
    class="radio-large-wrap flex flex-grow rounded-md border-2 border-gray-over-dark bg-off-white p-0"
    :class="{ activeButton: active }"
  >
    <label
      class="radio-large-container"
      :class="{ activeButtonText: active }"
    >
      <slot name="beforeText" />
      {{ item }}
      <slot name="afterText" />
      <input
        type="checkbox"
        :name="name"
        :value="item"
        :checked="active"
        @click="handleSelect"
      />
      <span class="checkmark" />
    </label>
  </div>
</template>

<script>
export default {
  name: 'RadioButtonLarge',
  props: {
    item: String,
    activeItems: Array,
    handleSelect: {
      type: Function,
    },
    name: [String, Number],
    active: [Boolean, Object],
  },
};
</script>

<style>
/* Custom CSS for Checkboxes */
/* Template used from W3 schools https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_custom_checkbox */
/* The container */
.radio-large-container {
  @apply relative block flex h-auto cursor-pointer items-center py-4 pl-12 pr-4 text-left text-xs text-body-color sm:text-sm;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.radio-large-container input {
  @apply absolute h-0 w-0 cursor-pointer opacity-0;
}

/* Create a custom checkbox */
.radio-large-container .checkmark {
  @apply absolute left-2 h-6 w-6 rounded-md border border-gray-over-dark bg-white;
  /* top: 1.75rem; */
  /* top: 50%;
  transform: translate(0, -50%); */
}

/* When the checkbox is checked, add a yellow background */
.radio-large-container input:checked ~ .checkmark {
  @apply border-yellow-500 bg-yellow-500;
}

/* Create the checkmark/indicator (hidden when not checked) */
.radio-large-container .checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.radio-large-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.radio-large-container .checkmark:after {
  left: 7px;
  top: 1px;
  width: 9px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.radio-large-wrap.activeButton {
  @apply flex flex-wrap rounded-md border-yellow-500 bg-white;
  border-color: #f8c617 !important;
  background-color: white !important;
}

.activeButtonText {
  @apply text-dark-gray;
}
</style>
